import { Dropdown } from "react-bootstrap";
import { unit } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import CartItemUnitDropdownItem from "./CartItemUnitDropdownItem";
import CartUnitDropDownMenu from "./CartUnitDropDownMenu";
import SvgArrow from "../cart-item-icons/SvgArrow";

type TProps = {
  units: unit[];
  onSelect: (unitId: unit["id"]) => void;
  selectedId: number;
};

const CartItemUnitDropdown: React.FC<TProps> = ({
  onSelect,
  selectedId,
  units,
}) => {
  const selectedUnit = units.find((item) => item.id === selectedId);
  return (
    <Dropdown
      id={"dropdown" + selectedId}
      className="cart-item-units-dropdown"
      drop="down-centered"
    >
      <Dropdown.Toggle
        variant="secondray"
        id={"dropdown-basic" + selectedId}
        className="cart-item-units-dropdown "
        style={{ height: "100%" }}
      >
        {selectedUnit?.name} <SvgArrow />
      </Dropdown.Toggle>

      <Dropdown.Menu as={CartUnitDropDownMenu}>
        {units.map(({ id, name, price }) => (
          <Dropdown.Item key={id} className="cart-item-units-menu-item p-0">
            <CartItemUnitDropdownItem
              onSelect={(id) => {
                onSelect(id);
              }}
              isSelected={id === selectedId}
              unitId={id}
              unitName={name}
              price={price}
            />
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CartItemUnitDropdown;
